import { BillingInterval, PlanType } from "sdk/types";

export * from "./ids";
export * from "./routes";
export * from "./sharedProps";

export const CONCEIVE_SUPPORT_EMAIL = "support@weconceive.com";

export const PRIVACY_POLICY_URL =
  "https://docs.google.com/document/d/14Q5QvPzbHkEHl9Sw5lMclqXJhzWyebXY/edit?usp=sharing&ouid=111222304416454903881&rtpof=true&sd=true";
export const TERMS_OF_SERVICE_URL =
  "https://docs.google.com/document/d/1w-v7ori4bE1fkXVDl1I-Vi2UMMmRGDrD/edit?usp=sharing&ouid=111222304416454903881&rtpof=true&sd=true";
export const CONSUMER_HEALTH_PRIVACY_NOTICE_URL =
  "https://docs.google.com/document/d/1Y5FoZRowfFSo3_ebtjmnPPXAAHWky0MJ";

// TODO: DRY up the pricing calls, particularly in the translation files -- https://app.clickup.com/t/8676zwc59
type Prices = Record<PlanType, number>;
export const prices: Prices = {
  plus: 49,
  premium: 129,
};

const prices1Month: Prices = {
  plus: 49,
  premium: 129,
};

const prices3Months: Prices = {
  plus: 129,
  premium: 349,
};

const prices6Months: Prices = {
  plus: 249,
  premium: 659,
};

const prices12Months: Prices = {
  plus: 469,
  premium: 1239,
};

export const billingIntervals: BillingInterval[] = ["1-month", "3-months"];

export const pricesByBillingIntervalAndPlan: Record<BillingInterval, Prices> = {
  "1-month": prices1Month,
  "3-months": prices3Months,
  "6-months": prices6Months,
  "12-months": prices12Months,
};

export const monthlyPricesByIntervalAndPlan: Record<BillingInterval, Prices> = {
  "1-month": {
    plus: prices1Month.plus,
    premium: prices1Month.premium,
  },
  "3-months": {
    plus: prices3Months.plus / 3.0,
    premium: prices3Months.premium / 3.0,
  },
  "6-months": {
    plus: prices6Months.plus / 6.0,
    premium: prices6Months.premium / 6.0,
  },
  "12-months": {
    plus: prices12Months.plus / 12.0,
    premium: prices12Months.premium / 12.0,
  },
};
